import { pick } from 'lodash';
import moment from 'moment';
import React, { Component } from 'react';
import { graphql, createFragmentContainer } from 'react-relay';
import { withRouter, Link } from 'react-router-dom';
import DatePicker from 'react-datepicker';

import {
  StoreProvider,
  Label,
  ErrorFlash,
  ImageUploader,
  Dialog,
} from '../../components';
import { updateHappening, deleteHappening } from '../../mutations';
import { HOURS } from '../constants';
import DatePresenter from '../../presenters/DatePresenter';

import 'react-datepicker/dist/react-datepicker.css';

export class HappeningEditView extends Component {
  constructor(props) {
    super(props);

    const happening = props.happening || {};
    const store = happening.store || {};

    this.state = {
      title: happening.title || '',
      url: happening.url || '',
      imageUrl: happening.imageUrl || null,
      backgroundImage: null,
      errors: null,
      showsDeletionDialog: false,
      startDate: moment(happening.startDate).startOf('day').toDate(),
      startTime: moment(happening.startDate).hour(),
      endDate: moment(happening.endDate).startOf('day').toDate(),
      endTime: moment(happening.endDate).hour(),
      description: happening.description || '',
      storeId: store.id || '',
      details: happening.details || '',
      callToAction: happening.callToAction || '',
    };
  }

  // update events
  handleUpdateTitle = (event) => {
    this.setState({ title: event.target.value });
  };

  handleUpdateUrl = (event) => {
    this.setState({ url: event.target.value });
  };

  handleUpdateDetails = (event) => {
    this.setState({ details: event.target.value });
  };

  handleUpdateCallToAction = (event) => {
    this.setState({ callToAction: event.target.value });
  };

  handleStartDate = (date) => {
    if (date !== null) {
      this.setState({ startDate: date });
    }
  };

  handleStartTime = (event) => {
    let hour = event.target.value;
    this.setState({ startTime: hour });
  };

  handleImageUploaded = (image) => {
    this.setState({ backgroundImage: image });
  };

  handleEndDate = (date) => {
    if (date !== null) {
      this.setState({ endDate: date });
    }
  };

  handleEndTime = (event) => {
    let hour = event.target.value;
    this.setState({ endTime: hour });
  };

  handleUpdateDescription = (event) => {
    this.setState({ description: event.target.value });
  };

  handleSubmit = (event) => {
    event.preventDefault();

    const { relay, happening } = this.props;
    const attributes = pick(this.state, [
      'title',
      'url',
      'backgroundImage',
      'description',
      'details',
      'callToAction',
      'storeId',
    ]);

    attributes.startDate = moment(this.state.startDate)
      .hour(this.state.startTime)
      .minutes(0)
      .toDate();
    attributes.endDate = moment(this.state.endDate)
      .hour(this.state.endTime)
      .minutes(0)
      .toDate();

    updateHappening(
      relay.environment,
      { id: happening.id, ...attributes },
      {
        onCompleted: this.handleSubmitSuccess,
      }
    );
  };

  handleSubmitSuccess = (response) => {
    let { errors } = response.updateHeroOffer;
    if (errors) {
      this.setState({ errors });
    } else {
      this.props.history.push('/happenings/tab/active');
    }
  };

  // delete offer
  handleDeleteHappening = () => {
    this.setState({ showsDeletionDialog: true });
  };

  handleCancelDeletion = () => {
    this.setState({ showsDeletionDialog: false });
  };

  handleConfirmDeletion = () => {
    this.setState({ showsDeletionDialog: false });

    const { history, happening, lists, relay } = this.props;
    deleteHappening(relay.environment, happening.id, lists.id, {
      onCompleted: () => history.push('/happenings/tab/active'),
      onError: (error) => console.error(`commit failed: ${error}`),
    });
  };

  handleUpdateStore = (event) => {
    this.setState({ storeId: event.target.value });
  };

  render() {
    let stores = this.props.lists.stores.edges.map((e) => e.node);
    let { errors } = this.state;

    return (
      <div className="happening-edit">
        <Dialog
          className="deletion"
          isOpen={this.state.showsDeletionDialog}
          message="This will delete the happening. Are you sure you want to proceed?"
          onConfirm={this.handleConfirmDeletion}
          onCancel={this.handleCancelDeletion}
        />
        <form className="happening-form" onSubmit={this.handleSubmit}>
          <div className="form-header">
            <h2>Edit Happening</h2>
            <div className="form-header-actions">
              <div
                id="deleteHappening"
                className="button delete"
                onClick={this.handleDeleteHappening}
              >
                Delete
              </div>
              <Link to={`/messages/happening/${this.props.happening.id}/new`}>
                <button className="button">New Message</button>
              </Link>
              <input
                id="saveHappening"
                className="happening-submit"
                type="submit"
                defaultValue="Save"
              />
            </div>
          </div>

          <div className="form-fields">
            <ErrorFlash errors={errors} />

            <div className="form-group">
              <h3>General</h3>
              <div className="form-group-fields">
                <div className="form-group-column">
                  <div className="input">
                    <Label attr="title" text="Title" errors={errors} />
                    <input
                      type="text"
                      id="title"
                      value={this.state.title}
                      onChange={this.handleUpdateTitle}
                      required
                    />
                  </div>

                  <div className="input">
                    <Label
                      attr="description"
                      text="Description"
                      errors={errors}
                    />
                    <input
                      type="text"
                      id="description"
                      value={this.state.description}
                      onChange={this.handleUpdateDescription}
                    />
                  </div>

                  <div className="input">
                    <Label attr="url" text="Url" errors={errors} />
                    <input
                      type="text"
                      id="url"
                      value={this.state.url}
                      onChange={this.handleUpdateUrl}
                      required
                    />
                  </div>

                  <div className="input">
                    <Label attr="store" text="Store" errors={errors} />
                    <select
                      id="store"
                      value={this.state.storeId}
                      onChange={this.handleUpdateStore}
                    >
                      <option value=""> -- select a store -- </option>
                      {stores.map((store, i) => (
                        <option value={store.id} key={i}>
                          {store.name}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="input">
                    <Label
                      attr="callToAction"
                      text="Call To Action"
                      errors={errors}
                    />
                    <input
                      type="text"
                      id="callToAction"
                      value={this.state.callToAction}
                      onChange={this.handleUpdateCallToAction}
                    />
                  </div>

                  <div className="input">
                    <Label attr="details" text="Details" errors={errors} />
                    <textarea
                      id="details"
                      value={this.state.details}
                      onChange={this.handleUpdateDetails}
                    />
                  </div>
                </div>

                <div className="form-group-column">
                  <div className="input image-upload">
                    <Label attr="image" text="Image" errors={errors} />
                    <div className="image-upload-hint">
                      {"Image should be a .png or .jpg and be '750x200'"}
                    </div>
                    <ImageUploader
                      id="backgroundImage"
                      onUploaded={this.handleImageUploaded}
                      cover
                      source={this.state.imageUrl}
                      type="happening"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="form-group">
              <h3>Availability</h3>
              <div className="availability">
                <div className="availability-field start-date">
                  <Label attr="startDate" text="Start Date" errors={errors} />
                  <DatePicker
                    id="startDate"
                    selected={DatePresenter.dateObject(this.state.startDate)}
                    onChange={(date) => this.handleStartDate(date)}
                    dateFormat="MM-dd-yyyy"
                  />
                </div>
                <div className="availability-field start-time">
                  <div>
                    <Label attr="startTime" text="Start Time" />
                    <select
                      id="startTime"
                      value={this.state.startTime}
                      onChange={this.handleStartTime}
                    >
                      {HOURS.map((hour, i) => (
                        <option value={i + 1} key={i}>
                          {hour}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                <div className="availability-field end-date">
                  <Label attr="endDate" text="End Date" errors={errors} />
                  <DatePicker
                    id="endDate"
                    selected={DatePresenter.dateObject(this.state.endDate)}
                    onChange={(date) => this.handleEndDate(date)}
                    dateFormat="MM-dd-yyyy"
                  />
                </div>
                <div className="availability-field end-time">
                  <div>
                    <Label attr="endTime" text="End Time" />
                    <select
                      id="endTime"
                      value={this.state.endTime}
                      onChange={this.handleEndTime}
                    >
                      {HOURS.map((hour, i) => (
                        <option value={i + 1} key={i}>
                          {hour}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    );
  }
}

const HappeningEditContainer = withRouter(
  createFragmentContainer(HappeningEditView, {
    happening: graphql`
      fragment HappeningEdit_happening on HeroOffer {
        id
        title
        url
        imageUrl
        startDate
        endDate
        description
        details
        callToAction
        store {
          id
        }
      }
    `,
    lists: graphql`
      fragment HappeningEdit_lists on Lists {
        id
        stores(first: 1000) {
          edges {
            node {
              id
              name
            }
          }
        }
      }
    `,
  })
);

export default class HappeningEdit extends Component {
  render() {
    return (
      <StoreProvider
        modern
        container={HappeningEditContainer}
        query={graphql`
          query HappeningEditQuery($happeningId: ID!) {
            happening: heroOffer(id: $happeningId) {
              ...HappeningEdit_happening
            }

            lists {
              ...HappeningEdit_lists
            }
          }
        `}
      />
    );
  }
}
